import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginInput, Query, UserProfile } from "generated-interfaces/graphql";
import { saveUserState } from "utils/local-storage";
import { setAuthToken } from "utils/network";

export interface UserState {
    loginLoading: boolean;
    userProfile: UserProfile | null;
    isLoggedIn: boolean;
    token: string | null;
    didAttemptPreviousStateLoad: boolean;
}

const initialState: UserState = {
    loginLoading: false,
    userProfile: null,
    isLoggedIn: false,
    token: null,
    didAttemptPreviousStateLoad: false,
};

export const loginAction = createAction<LoginInput>("LOGIN");
export const checkAuthStatusAction = createAction("CHECK_AUTH_STATUS");
export const loadUserState = createAction("LOAD_USER_STATE");

export const userState = createSlice({
    name: "user",
    initialState,
    reducers: {
        loginInit: (state) => {
            state.loginLoading = true;
        },
        loginSuccess: (state, action: PayloadAction<Query["login"]>) => {
            state.userProfile = action.payload;
            state.isLoggedIn = true;
            state.loginLoading = false;
            saveUserState(state);
        },
        loginFailed: (state) => {
            state.loginLoading = false;
        },
        logout: (state) => {
            state.userProfile = initialState.userProfile;
            state.isLoggedIn = initialState.isLoggedIn;
            state.token = initialState.token;
            state.loginLoading = initialState.loginLoading;
            setAuthToken(null);
            saveUserState(state);
        },
        authCheckSuccess: (
            state,
            action: PayloadAction<Query["authStatus"]>
        ) => {
            if (state.userProfile) {
                state.token = action.payload.authorizationToken;
                state.userProfile.authorizationToken =
                    action.payload.authorizationToken;
                saveUserState(state);
            }
        },
        loadUserStateSuccess: (state) => {
            state.didAttemptPreviousStateLoad = true;
        },
    },
});

export const USER_ACTIONS = userState.actions;
